import {useEffect, useRef} from "react";

const FIVE_MINUTES = 15 * 60 * 1000;
const ONE_MINUTE = 60 * 1000;

/* Events that count as the user being present. */
const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'click', 'scroll'];

export const useAutoLogOut = (logout, isAuthenticated) => {

    /* The timestamp lives in a ref, not in state. It used to be state, and it
       also sat in the effect's dependency list, so every single mousemove
       re-rendered the whole App tree and tore down and rebuilt the listeners
       and the interval. A ref is updated in place: the interval below reads
       the current value without anything re-rendering. */
    const lastActivityRef = useRef(Date.now());

    useEffect(() => {
        if (!isAuthenticated) return;

        const markActivity = () => {
            lastActivityRef.current = Date.now();
        };
        ACTIVITY_EVENTS.forEach((name) => document.addEventListener(name, markActivity));

        const checkInactivity = async () => {
            if (window.location.pathname === '/') return;
            if (Date.now() - lastActivityRef.current <= FIVE_MINUTES) return;

            await logout();
            window.location.replace('/');
        };

        const inactivityInterval = setInterval(checkInactivity, ONE_MINUTE);

        return () => {
            ACTIVITY_EVENTS.forEach((name) => document.removeEventListener(name, markActivity));
            clearInterval(inactivityInterval);
        };
    }, [logout, isAuthenticated]);

};
